import { CmpApiModel } from '../CmpApiModel.js';
import { Command } from './Command.js';
export class RemoveEventListenerCommand extends Command {
    respond() {
        this.invokeCallback(CmpApiModel.eventQueue.remove(this.param));
    }
}
